import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { HomePage } from './components/Resident/HomePage';
import { Resident } from './components/Resident/Resident';

import { Dashboard } from './components/Resident/Dashboard';

import { SendEmail } from './components/Resident/SendEmail';
import { NonResident } from './components/NonResident/NonResident';
import { FileUpload } from './components/NonResident/FileUpload';
import { VerifyProfile } from './components/UserManagement/VerifyProfile';
import { ForgetPassword } from './components/Login/ForgetPassword';
import './custom.css';
import { FetchRemitter } from './components/Remitter/FetchRemitter';
import { Login } from './components/Login/Login';
import { FetchAssignment } from './components/Assignment/FetchAssignment';
import { AddEditAssignment } from './components/Assignment/AddEditAssignment';
import { Form15GH } from './components/Form15GH/Form15GH';
import { Form121 } from './components/Form15GH/Form121';
import { OtherResident } from './components/Resident/OtherResident';
import { UserProfile } from './components/UserManagement/UserProfile';
import { FetchBeneficiary } from './components/Beneficiary/FetchBeneficiary';
import { AddEditBeneficiary } from './components/Beneficiary/AddEditBeneficiary';
import './Asset/Css/Site.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { faHome, faUser, faUserAlt, faCoffee, faPencilAlt, faCloudDownloadAlt, faIdCard, faKey, faCheckCircle, faPenSquare, faCheckSquare, faEye, faClock } from '@fortawesome/free-solid-svg-icons'
import { AdminNotification } from './components/Dashboard/AdminNotification';
import { DigitalSignatureForm15GH } from './components/Form15GH/DigitalSignatureForm15GH';
import { Error404 } from './components/Handle Error/Error404';
import { Success } from './components/Handle Error/Success';
import { Cancel } from './components/Handle Error/Cancel';
import { Error } from './components/Handle Error/Error';
import { BrowserSupport } from './components/Handle Error/BrowserSupport';
import { BulkXMLGeneration } from './components/Bulk Upload/BulkXMLGeneration';
import { ESignSuccess } from './components/Form15GH/ESignSuccess';
import { ESignCancel } from './components/Form15GH/ESignCancel';
import { ESignFailure } from './components/Form15GH/ESignFailure';
import { FetchPart2Details } from './components/Part2/FetchPart2Details';
import { FormGrid } from './components/Form15GH/FormGrid';
import { FormGridComplete } from './components/Form15GH/FormGridComplete';
import { Log } from 'oidc-client';
import { SignUp } from './components/Login/SignUp';
import { SignIn } from './components/Login/SignIn';
import { ResetPassword } from './components/Login/ResetPassword';
import { OfflineResident } from './components/UserManagement/OfflineResident';
import { FillManually } from './components/UserManagement/FillManually';
import { Offlineform15GH } from './components/UserManagement/Offlineform15GH';



library.add(fab, faHome, faUser, faUserAlt, faCoffee, faPencilAlt, faCloudDownloadAlt, faIdCard, faKey, faCheckCircle, faPenSquare, faCheckSquare, faEye, faClock)

export default class App extends Component {
    static displayName = `Debenture's Hub`;

    render() {
        return (
            <Layout>
                <Route exact path='/' component={HomePage} />
                <Route exact path='/Resident' component={Resident} />
                <Route exact path='/Resident/Dashboard' component={Dashboard} />
                <Route exact path='/Resident/SendEmail' component={SendEmail} />

                <Route exact path='/Nexdigm/Dashboard' component={Home} />
                <Route exact path='/Nexdigm/Assignment' component={FetchAssignment} />
                <Route exact path='/Nexdigm/Add-Assignment' component={AddEditAssignment} />

                <Route exact path='/Nexdigm/Shareholder-Details' component={FetchBeneficiary} />
                <Route exact path='/Nexdigm/View-Shareholder' component={AddEditBeneficiary} />

                <Route exact path='/Nexdigm/Part2' component={FetchPart2Details} />
                <Route exact path='/Nexdigm/Report' component={AdminNotification} />

                <Route exact path='/SignUp' component={SignUp} />
                <Route exact path='/SignIn' component={SignIn} />
                <Route exact path='/ResetPassword' component={ResetPassword} />

                <Route exact path='/NonResident' component={NonResident} />
                <Route exact path='/NonResident/FileUpload' component={FileUpload} />

                <Route exact path='/Resident/Form15GH' component={Form15GH} />
                <Route exact path='/Resident/Form121' component={Form121} />
                <Route exact path='/Resident/Others' component={OtherResident} />


                <Route exact path='/:CompanyName/Forgot-Password' component={ForgetPassword} />
                <Route exact path='/:CompanyName/fetchRemitter' component={FetchRemitter} />
                <Route exact path='/Resident/Form15GH/Success' component={Form15GH} />
                <Route exact path='/:CompanyName/New-User' component={VerifyProfile} />
                <Route exact path='/:CompanyName/userProfile' component={UserProfile} />

                <Route exact path='/:CompanyName/Bulk-Upload' component={BulkXMLGeneration} />
                <Route exact path='/:CompanyName/emSigner' component={DigitalSignatureForm15GH} />
                <Route exact path='/Resident/Form15GH/ESignSuccess' component={ESignSuccess} />
                <Route exact path='/Resident/Form15GH/ESignCancel' component={ESignCancel} />
                <Route exact path='/Resident/Form15GH/ESignFailure' component={ESignFailure} />
               
                <Route exact path='/:CompanyName/FormGrid' component={FormGrid} />
                <Route exact path='/:CompanyName/FormGridComplete' component={FormGridComplete} />
                <Route exact path='/Error/404' component={Error404} />
                <Route exact path='/Error/Browser-Not-Supported' component={BrowserSupport} />

                <Route exact path='/OfflineResident' component={OfflineResident} />
                <Route exact path='/FillManually' component={FillManually} />
                <Route exact path='/Offlineform15GH' component={Offlineform15GH} />
            </Layout>
        );
  }
}
